var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"xpb-icon",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('use',{attrs:{"xlink:href":`#${_vm.iconClass}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }